<template>
	<v-form
		v-if="orderrowData && reasons"
		ref="form"
		v-model="valid"
	>
		<v-row>
			<v-col>
				<h3>{{ $gettext('Cancel policy') + ' ' + orderrowData.identifier }}</h3>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<h4>
					<translate>We are sorry that you no longer wish to insure your device with us. Why do you want to cancel?</translate>
				</h4>
				<v-radio-group
					v-model="selectedReason"
					class="mb-0"
					:rules="[v => !!v || $gettext('Reason required')]"
				>
					<div
						v-for="reason in reasons"
						:key="reason.id"
					>
						<radio-button
							v-if="$refs.form"
							:value="reason"
							:label="reason.name"
							:has-error="valid === false"
						/>
						<v-text-field
							v-if="reason.other"
							v-model="reasonContext"
							:disabled="!selectedReason || selectedReason.name !== reason.name"
							class="pa-0 ma-0"
							variant="outlined"
							color="primary"
							:rules="[v => (!selectedReason || !selectedReason.other || !!v) || $gettext('Reason required')]"
						/>
					</div>
				</v-radio-group>
				<div v-if="alreadyDirectDebitted">
					<h4><translate>If we process your cancellation after the 18th of the month the direct debit order has already been sent to your bank.</translate></h4>
					<ul>
						<li><h4><translate>You may get one more write-off this month.</translate></h4></li>
						<li><h4><translate>Any overpayments will be reimbursed automatically.</translate></h4></li>
						<li><h4><translate>You will have your overpayments back available on your bank account in 6 weeks.</translate></h4></li>
					</ul>
				</div>
				<h4>
					<translate>You will receive an email with a confirmation of your cancellation.</translate>
				</h4>
				<h4>
					<translate>Your cancellation period is 30 days, you can enter below when you want your insurance to end.</translate>
				</h4>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<date-picker
					v-model="endDate"
					name="Desired end date"
					:label="$gettext('Desired end date')"
					:min="orderrowData.minDate"
					:max="orderrowData.maxDate"
					color="primary"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-btn
					color="primary"
					:disabled="loading"
					@click="cancel"
				>
					<translate>Cancel</translate>
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-if="errorMessage">
			<v-col>
				<p style="color: red">
					{{ errorMessage }}
				</p>
			</v-col>
		</v-row>
		<v-row v-if="loading">
			<v-col>
				<v-progress-linear
					color="primary"
					indeterminate
				/>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'CancelPolicy',

	data () {
		return {
			orderrowId: null,
			alreadyDirectDebitted: false,
			orderrowData: null,
			endDate: '',
			loading: false,
			errorMessage: null,
			reasons: null,
			selectedReason: null,
			reasonContext: '',
			valid: true,
		};
	},

	mounted () {
		this.orderrowId = new URLSearchParams(window.location.search.substring(1)).get('id');
		this.alreadyDirectDebitted = (new Date()).getDate() >= 18;
		this.getOrderrowData();
	},

	methods: {
		/**
		 * Get the policy identifier with minimum, maximum, and suggested cancellation date
		 *
		 * @returns {void}
		 */
		getOrderrowData () {
			axios.get('/api/v0/orderrows/canceldata', {
				'params': {
					'id': this.orderrowId
				}
			}).then(({
				data: data
			}) => {
				this.endDate = data.suggestedDate;
				this.orderrowData = data;
			}).catch((error) => {
				window.Sentry.captureException(error);
			});

			axios.get('/api/v0/cancellationreasons/dashboard', {
				params: {
					sortBy: 'id'
				}
			}).then(({
				data: {
					result
				}
			}) => {
				this.reasons = result;
			}).catch((error) => {
				window.Sentry.captureException(error);
			});
		},

		/**
		 * Cancel the viewed policy
		 *
		 * @returns {void}
		 */
		async cancel () {
			if (!(await this.$refs.form.validate()).valid) {
				return;
			}

			this.errorMessage = null;
			this.loading = true;

			const postData = {
				'id': this.orderrowId,
				'endDate': this.endDate,
				'cancellationReasonId': this.selectedReason.id,
			};

			if (this.selectedReason.other) {
				postData.cancellationContext = this.reasonContext;
			}
			axios.post('/api/v0/orderrowcancelevents', postData).then(() => {
				window.location.href = '/dashboard/policies/cancelled?id=' + this.orderrowId;
			}).catch((error) => {
				if (!error.response || error.response.status === 500) {
					if (error.message && error.message === 'Request aborted') {
						return;
					}
					this.errorMessage =
						this.$gettext('Error cancelling your policy') +
						': ' +
						this.$gettext('Please try again later');
					window.captureException(error);
				} else {
					this.errorMessage = error.response.data;
				}
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>
